import React from 'react';
import classes from "./SliderBox.module.css";
import { BsArrowRight } from "react-icons/bs";

export default function SliderBox({data}) {
  // const navigate = useNavigate();
  return (
    <div className={classes.mainDiv}>
      <p className={`f-26 fw-600 ${classes.title}`}>{data?.title}</p>
      <p className="f-15 fw-400">{data?.content}</p>
      <p className={classes.link}>{`Read More`} <BsArrowRight size={20}/></p>
    </div>
  )
}
